import React, { useState, useEffect } from "react";
import { aboutBg, services61 } from "../../../../assets/images"; // Örnek görsel eklendi
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Reaming = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState("300px");

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? "200px" : "300px");
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: heroHeight,
        }}
      >
        <SubOtherHero title="Reaming services" />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10">
          {/* Left Content */}
          <div className="md:w-2/3">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Reaming services")}
            </p>
            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Borehole Enlarger")}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "The Borehole Enlargement tool provides a simple and reliable solution for enlarging existing wellbore or reaming-while-drilling new hole. Delivering utmost in durability regardless of the formation or operating parameters, it is suitable for all formations ranging from highly abrasive to loosely consolidated and ideal for use with rotary steerable systems, extended reach drilling and back reaming requirements. The Hydraulic Borehole Enlarger consistently produces a full-gauge hole and enhances overall drilling efficiency."
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Designed with an exceptional mechanical force advantage, and application – specific cutter blocks, the Hydraulic Borehole Enlarger opens completely and consistently, delivering simple, dependable and cost-effective enlargement in a single run. With hydraulic activation, through ball drop or controlled pressure drop, cutter deployment is independent of BHA weight,"
              )}
            </p>
          </div>

          {/* Right Image */}
          <div className="mt-8 md:mt-0 md:w-1/3">
            <img
              src={services61}
              alt="Service Illustration"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Reaming;
